function equalizeHeights() {
  const titles = document.querySelectorAll("[data-multicolumn-title]");

  titles.forEach(el => {
    el.style.height = "auto";
  });

  if (window.innerWidth > 768 && titles.length > 0) { 
    let maxHeight = 0;

    titles.forEach(el => {
      if (el.offsetHeight > maxHeight) {
        maxHeight = el.offsetHeight;
      }
    });

    titles.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  }
}

document.addEventListener("DOMContentLoaded", equalizeHeights);
window.addEventListener("resize", equalizeHeights);